export enum EmailList {
  // noinspection JSUnusedGlobalSymbols
  Discount = 0,
  Engage = 1,
  Review = 2,
  Update = 3
}
